export class LogAcesso {
    public cdFazenda!: number;
    public cdPessoa!: number;
}
